import React from 'react';
import excel from './excel';

/**
 * id
 * name
 * amount
 * address
 * dateStart
 * dateEnd
 * type
 * client
 * intro
 * memo
 */

const DataPage = (props) => {
  const result = excel.map(c => {
    let date = c.年度.split('~');
    let dateStart;
    let dateEnd;
    if(date.length === 1) {
      const year = +date[0].split('/')[0]+1911;
      const month = date[0].split('/')[1];
      dateStart = `${year}/${month}/01 09:00:00`;
      dateEnd = `${year}/${month}/${new Date(year, month, 0).getDate()} 09:00:00`;
    } else {
      const year = +date[1].split('/')[0]+1911;
      const month = date[1].split('/')[1];
      dateStart = `${+date[0].split('/')[0]+1911}/${date[0].split('/')[1]}/01 09:00:00`;
      dateEnd = `${year}/${month}/${new Date(year, month, 0).getDate()} 09:00:00`;
    }
    return {
      dateEnd,
      dateStart,
      type: [1, 2, 3].reduce((arr, value) => {
        if(c[`工程種類${value}`]) {
          arr.push(c[`工程種類${value}`]);
        }
        return arr;
      }, []),
      id: c.項次,
      memo: c.備註,
      name: c.標案名稱,
      address: c.地點,
      intro: c.詳細範圍,
      amount: c.標案金額,
      client: c.單位種類1,
      organizer: c.主辦單位,
    };
  });
  console.warn(result);
  return (
    <div>DataPage</div>
  )
}

export default DataPage



// WEBPACK FOOTER //
// ./src/DataPage.js